import { CONSTS } from '../../config/objectConst'

const isEnabled = import.meta.env.PUBLIC_SENTRY === 'true'

async function initSentry(userId: string) {
	if (!isEnabled) {
		return
	}

	const { init, setContext, setTag } = await import('@sentry/react')

	init({
		allowUrls: [
			'app.snaily.io',
			'sandbox-app.snaily.io',
			'chrome-extension://febgaeoegckcdcdhammknmiobpjkpgbe',
			'chrome-extension://gjncjmifcnnbaggdakbkgdmfkmknijhb'
		],
		//integrations: [new BrowserTracing()],

		dsn: 'https://c563bd35cb0f4697bda0dfe29df80483@o1303236.ingest.sentry.io/6541994',
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.5
	})

	setContext('app', {
		userId,
		version: CONSTS.APP_VERSION
	})
	setTag('app_version', CONSTS.APP_VERSION)
}

async function reportToSentry(error: unknown) {
	if (isEnabled) {
		const { captureException } = await import('@sentry/react')

		captureException(error)
	}
}

export { initSentry, reportToSentry }
